module.exports = __webpack_public_path__ + "media/images/ushinohiroba_main_image-c0a19b9ab4fb63a10aa128d4668340f9.png";